import { Component, Injector, OnInit } from '@angular/core';
import { AppComponentBase } from 'src/shared/common/app-component-base';

import { AppMenu } from './app-menu';
import { AppNavigationService } from './app-navigation.service';

/* eslint-disable @typescript-eslint/no-unused-vars */
@Component({ standalone: false, templateUrl: './adm-bar.component.html', selector: '[adm-bar]' })
export class AdmBarComponent extends AppComponentBase implements OnInit {
  menu: AppMenu = null;
  showMenu = false;

  constructor(
    injector: Injector,
    private _appNavigationService: AppNavigationService,
  ) {
    super(injector);
  }

  ngOnInit() {
    this.menu = this._appNavigationService.getAdminMenu();
    this.menu.items.forEach(element => {
      if (this.showMenuItem(element)) {
        this.showMenu = true;
        return;
      }
    });
  }

  showMenuItem(menuItem): boolean {
    return this._appNavigationService.showMenuItem(menuItem);
  }
}
